import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";

const UnauthorizedPage = () => {
    const navigate = useNavigate();

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                className="w-100"
                style={{ maxWidth: "400px" }}
            >
                <Card className="shadow">
                    <Card.Body className="p-4 text-center">
                        <h4 className="text-danger mb-3">Access Denied</h4>
                        <p>You do not have permission to view this page.</p>
                        <Button variant="primary" onClick={() => navigate("/")}>
                            Go to Dashboard
                        </Button>
                        <Button variant="secondary" className="mt-2" onClick={() => navigate("/login")}>
                            Login as Another User
                        </Button>
                    </Card.Body>
                </Card>
            </motion.div>
        </Container>
    );
};

export default UnauthorizedPage;
